/* XECAR · Páginas de marca: entradas al hacer scroll, pestañas de catálogo y cifras que cuentan */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Entradas escalonadas
  const items = document.querySelectorAll('.xm [data-xm-r]');
  if (reduce || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('is-in'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach((el) => io.observe(el));
  }

  // Pestañas del catálogo
  document.querySelectorAll('.xm [data-xm-tabs]').forEach((box) => {
    const tabs = [...box.querySelectorAll('[role="tab"]')];
    const show = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = box.querySelector('#' + t.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; p.classList.toggle('is-active', on); }
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => show(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        show(n, true);
      });
    });
  });

  // Cifras que cuentan al aparecer
  const nums = document.querySelectorAll('.xm [data-xm-count]');
  const run = (el) => {
    const end = parseFloat(el.dataset.xmCount), pre = el.dataset.pre || '', suf = el.dataset.suf || '';
    if (reduce) { el.textContent = pre + end + suf; return; }
    const t0 = performance.now(), dur = 1400;
    const step = (t) => {
      const k = Math.min(1, (t - t0) / dur), v = Math.round(end * (1 - Math.pow(1 - k, 3)));
      el.textContent = pre + v + suf;
      if (k < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  if ('IntersectionObserver' in window) {
    const io2 = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { run(e.target); io2.unobserve(e.target); } }), { threshold: 0.5 });
    nums.forEach((n) => io2.observe(n));
  }
})();

/* Video de marca: se abre en grande en una ventana y se detiene al cerrar */
(() => {
  document.querySelectorAll('.xm [data-xm-video]').forEach((btn) => {
    const sec = btn.closest('section');
    const dlg = sec && sec.querySelector('.xm-modal');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const frame = dlg.querySelector('.xm-modal__frame');
    const close = () => { dlg.close(); };
    dlg.addEventListener('close', () => { frame.innerHTML = ''; });
    dlg.addEventListener('click', (e) => { if (e.target === dlg) close(); });
    dlg.querySelector('.xm-modal__x').addEventListener('click', close);
    btn.addEventListener('click', () => {
      const id = btn.dataset.xmVideo, type = btn.dataset.xmVtype;
      const src = type === 'vimeo'
        ? `https://player.vimeo.com/video/${id}?autoplay=1`
        : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&modestbranding=1`;
      frame.innerHTML = `<iframe src="${src}" title="Video de Atos" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
      dlg.showModal();
    });
  });
})();
